export const MOVES = [
    {
      id : 1,
      todo: 'Move 50 steps',
      category: 'Motion'
    },
    {
      id : 2,
      todo: 'Move -50 steps',
      category: 'Motion'
    },
    {
      id : 3,
      todo: 'Move up 50 steps',
      category: 'Motion'
    },
    {
      id : 4,
      todo: 'Move down 50 steps',
      category: 'Motion'
    },
    {
      id : 5,
      todo: 'Go to x: 0 y: 0',
      category: 'Motion'
    },
    {
      id : 6,
      todo: 'turn 360 degrees',
      category: 'Motion'
    },
    {
      id : 21,
      todo: 'Go to coordinates',
      category: 'Motion'
    },
    {
      id : 19,
      todo: 'show',
      category: 'Looks'
    },
    {
      id : 20,
      todo: 'hide',
      category: 'Looks'
    },
    {
      id : 7,
      todo: 'Say Hello for 5 sec',
      category: 'Looks'
    },
    {
      id : 8,
      todo: 'Think Hmmm for 3 sec',
      category: 'Looks'
    },
    {
      id : 16,
      todo: 'Say Bye',
      category: 'Looks'
    },
    {
      id : 18,
      todo: 'Say Hii',
      category: 'Looks'
    },
    {
      id : 17,
      todo: 'Think See you',
      category: 'Looks'
    },
    {
      id : 9,
      todo: 'Go to random position',
      category: 'Motion'
    },
    {
      id: 13,
      todo: 'size increase',
      category: 'Looks'
    },
    {
      id: 14,
      todo: 'size decrease',
      category: 'Looks'
    },
    {
      id: 22,
      todo: 'Set size small',
      category: 'Looks'
    },
    {
      id: 23,
      todo: 'Set size medium',
      category: 'Looks'
    },
    {
      id: 24,
      todo: 'Set size large',
      category: 'Looks'
    },
    {
      id: 15,
      todo: 'repeat',
      category: 'Control'
    },
    {
      id : 10,
      todo: 'turn 90 degrees',
      category: 'Motion'
    },
    {
      id : 11,
      todo: 'turn 135 degrees',
      category: 'Motion'
    },
    {
      id : 12,
      todo: 'turn 180 degrees',
      category: 'Motion'
    },
    {
      id: 25,
      todo: 'Play Meow Sound',
      category: 'Sound'
    },
    {
      id: 26,
      todo: 'Play Pop Sound',
      category: 'Sound'
    },
    {
      id: 27,
      todo: 'Play Bell Sound',
      category: 'Sound'
    },
    {
      id: 28,
      todo: 'Play Drum Beat',
      category: 'Sound'
    },
    {
      id: 29,
      todo: 'Play Piano Note',
      category: 'Sound'
    },
    {
      id: 30,
      todo: 'Play Laugh Sound',
      category: 'Sound'
    },
    {
      id: 31,
      todo: 'Increase Volume',
      category: 'Sound'
    },
    {
      id: 32,
      todo: 'Decrease Volume',
      category: 'Sound'
    }
];

export const CATEGORIES = {
  Motion: '#4C97FF',
  Looks: '#9966FF',
  Sound: '#CF63CF',
  Control: '#FFAB19',
  Events: '#FFD500',
  Sensing: '#5CB1D6',
  Operators: '#59C059',
  Variables: '#FF8C1A',
  'My Blocks': '#FF6680'
};

export const WARN_MSG_SIZE = 'Size out of bounds';
export const WARN_MSG_POS = 'Position out of  bounds';

export const PAGES = [];
